import React from 'react'
import Link from 'gatsby-link'
import get from 'lodash/get'
import Script from 'react-load-script'
import Helmet from 'react-helmet'

function initNetlifyIdentity() {
  if (typeof window !== 'undefined' && window.netlifyIdentity) {
    window.netlifyIdentity.on('init', (user) => {
      if (!user) {
        window.netlifyIdentity.on('login', () => {
          document.location.href = '/admin/'
        })
      }
    })
  }
  window.netlifyIdentity.init()
}

function BlogIndex(props) {
  const siteTitle = get(props, 'data.site.siteMetadata.title')
  const posts = get(props, 'data.allMarkdownRemark.edges')

  return (
    <div className="ph3 ph4-ns mw8-ns">
      <Helmet title={siteTitle} />
      <Script
        url="https://identity.netlify.com/v1/netlify-identity-widget.js"
        onLoad={initNetlifyIdentity}
      />
      {posts.map((post) => {
        if (post.node.path !== '/404/') {
          return (
            <article className="pv4" key={post.node.fields.id}>
              <h2 className="mt0">
                <Link to={post.node.fields.path} >
                  {post.node.frontmatter.title}
                </Link>
              </h2>
              <time className="t6 ttu tracked gray">
                <small>{post.node.frontmatter.date}</small>
              </time>
              {/* eslint-disable react/no-danger */}
              <p className="post lead" dangerouslySetInnerHTML={{ __html: post.node.excerpt }} />
              {/* eslint-enable react/no-danger */}
            </article>
          )
        }
        return null
      })}
    </div>
  )
}

export default BlogIndex

export const pageQuery = graphql`
  query IndexQuery {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          excerpt(pruneLength: 280)
          frontmatter {
            title
            date(formatString: "DD MMMM, YYYY")
          }
          fields {
            id
            path
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.jsx